<particle-dynamic-country-selector [configKey]="configKey"
                                   [selectedCountryCodes]="dialogField.value"
                                   (selectionChanged)="onSelectionChanged($event)"
></particle-dynamic-country-selector>
